(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-square-banner-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('split-square-carousel')) {
    class SplitSquareCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ssbc-track]');
        if (!this.track) return;

        this.realSlides = Array.from(this.track.children);
        this.realCount = this.realSlides.length;
        this.cloneCount = 0;

        this.prevBtn = this.querySelector('[data-ssbc-prev]');
        this.nextBtn = this.querySelector('[data-ssbc-next]');
        this.dotsWrap = this.querySelector('[data-ssbc-dots]');
        this.status = this.querySelector('[data-ssbc-status]');

        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.pauseReasons = new Set();
        this.autoplayTimer = null;
        this.settleTimer = null;

        if (this.realCount > 1) this.setupClones();

        this.bindEvents();
        this.renderDots();
        this.updateActiveState();
        this.maybeStartAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        clearTimeout(this.settleTimer);
        clearTimeout(this._resizeTimer);
        clearTimeout(this._pauseTimer);
        if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
      }

      itemsPerView() {
        return window.matchMedia('(min-width: 750px)').matches ? 2 : 1;
      }

      setupClones() {
        var count = Math.min(2, this.realCount);
        this.cloneCount = count;

        var headClones = this.realSlides.slice(-count).map(this.makeClone, this);
        var tailClones = this.realSlides.slice(0, count).map(this.makeClone, this);

        headClones.forEach(function (clone) {
          this.track.insertBefore(clone, this.track.firstChild);
        }, this);
        tailClones.forEach(function (clone) {
          this.track.appendChild(clone);
        }, this);

        var self = this;
        requestAnimationFrame(function () {
          var firstReal = self.track.children[self.cloneCount];
          if (firstReal) self.track.scrollLeft = firstReal.offsetLeft;
        });
      }

      makeClone(slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.querySelectorAll('a, button').forEach(function (el) {
          el.setAttribute('tabindex', '-1');
        });
        return clone;
      }

      bindEvents() {
        var self = this;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', function () {
            self.pauseFor('interaction');
            self.go(-1);
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', function () {
            self.pauseFor('interaction');
            self.go(1);
          });
        }

        this.addEventListener('mouseenter', function () { self.addPause('hover'); });
        this.addEventListener('mouseleave', function () { self.removePause('hover'); });
        this.addEventListener('focusin', function () { self.addPause('focus'); });
        this.addEventListener('focusout', function (event) {
          if (!self.contains(event.relatedTarget)) self.removePause('focus');
        });

        this.track.addEventListener('pointerdown', function () { self.addPause('interaction'); });
        this.track.addEventListener('pointerup', function () { self.pauseFor('interaction'); });
        this.track.addEventListener('touchstart', function () { self.addPause('interaction'); }, { passive: true });
        this.track.addEventListener('touchend', function () { self.pauseFor('interaction'); }, { passive: true });

        this.track.addEventListener('scroll', function () {
          clearTimeout(self.settleTimer);
          self.settleTimer = setTimeout(function () { self.onSettle(); }, 120);
        });

        this.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            self.pauseFor('interaction');
            self.go(-1);
            event.preventDefault();
          } else if (event.key === 'ArrowRight') {
            self.pauseFor('interaction');
            self.go(1);
            event.preventDefault();
          }
        });

        this._resizeHandler = function () {
          clearTimeout(self._resizeTimer);
          self._resizeTimer = setTimeout(function () {
            self.renderDots();
            self.updateActiveState();
            self.stopAutoplay();
            self.maybeStartAutoplay();
          }, 150);
        };
        window.addEventListener('resize', this._resizeHandler);
      }

      addPause(reason) {
        this.pauseReasons.add(reason);
        this.stopAutoplay();
      }

      removePause(reason) {
        this.pauseReasons.delete(reason);
        if (this.pauseReasons.size === 0) this.maybeStartAutoplay();
      }

      pauseFor(reason, delay) {
        this.addPause(reason);
        var self = this;
        clearTimeout(this._pauseTimer);
        this._pauseTimer = setTimeout(function () { self.removePause(reason); }, delay || 1200);
      }

      maybeStartAutoplay() {
        if (
          !this.autoplayEnabled ||
          this.reducedMotion ||
          this.realCount <= this.itemsPerView() ||
          this.pauseReasons.size > 0
        ) {
          return;
        }
        this.stopAutoplay();
        var self = this;
        this.autoplayTimer = setInterval(function () { self.go(1); }, this.autoplaySpeed);
      }

      stopAutoplay() {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      slideStep() {
        var slide = this.track.children[this.cloneCount] || this.track.children[0];
        if (!slide) return 0;
        var styles = getComputedStyle(this.track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      go(direction) {
        var amount = this.slideStep() * this.itemsPerView() * direction;
        this.track.scrollBy({ left: amount, behavior: this.reducedMotion ? 'auto' : 'smooth' });
      }

      onSettle() {
        if (this.cloneCount > 0) this.handleLoop();
        this.updateActiveState();
      }

      handleLoop() {
        var step = this.slideStep();
        if (!step) return;
        var children = Array.from(this.track.children);
        var index = Math.round(this.track.scrollLeft / step);

        if (index < this.cloneCount) {
          var forward = children[index + this.realCount];
          if (forward) this.track.scrollLeft = forward.offsetLeft;
        } else if (index >= this.cloneCount + this.realCount) {
          var backward = children[index - this.realCount];
          if (backward) this.track.scrollLeft = backward.offsetLeft;
        }
      }

      currentRealIndex() {
        var step = this.slideStep();
        if (!step) return 0;
        var index = Math.round(this.track.scrollLeft / step) - this.cloneCount;
        index = ((index % this.realCount) + this.realCount) % this.realCount;
        return index;
      }

      renderDots() {
        if (!this.dotsWrap) return;
        var perView = this.itemsPerView();
        var pageCount = Math.max(1, Math.ceil(this.realCount / perView));

        if (this.dotsWrap.dataset.pageCount == pageCount) return;
        this.dotsWrap.dataset.pageCount = pageCount;
        this.dotsWrap.innerHTML = '';

        if (pageCount <= 1) return;

        var self = this;
        for (var i = 0; i < pageCount; i += 1) {
          (function (i) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'ssbc__dot';
            dot.setAttribute('aria-label', 'Go to slide ' + (i + 1) + ' of ' + pageCount);
            dot.addEventListener('click', function () {
              self.pauseFor('interaction');
              var target = self.track.children[self.cloneCount + i * perView];
              if (target) self.track.scrollLeft = target.offsetLeft;
              self.updateActiveState();
            });
            self.dotsWrap.appendChild(dot);
          })(i);
        }
      }

      updateActiveState() {
        var perView = this.itemsPerView();
        var realIndex = this.currentRealIndex();
        var page = Math.floor(realIndex / perView);

        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === page);
            dot.setAttribute('aria-current', i === page ? 'true' : 'false');
          });
        }

        if (this.status) {
          var pageCount = Math.max(1, Math.ceil(this.realCount / perView));
          this.status.textContent = 'Showing slide ' + (page + 1) + ' of ' + pageCount;
        }
      }
    }

    customElements.define('split-square-carousel', SplitSquareCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
